import React from 'react';
import proptypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';
import { Paint, CounterTop, Drill } from '@one-thd/sui-icons';

const AddMaterialsToYourList = ({ url }) => {
  // The vertical padding (py-5 / @sm:py-12) carries the 16px ListTile leaves off the header
  // row's sui-mb-4 in this state, so the empty tile keeps the same natural height: a row of
  // equal-height carousel tiles doesn't shrink (and shift its populated neighbors) when an
  // empty tile is the tallest. Invisible once the panel fills a taller card, since its
  // content is centered.
  return (
    <div
      className="sui-flex sui-items-center sui-h-full
    sui-justify-between sui-gap-4 sui-bg-subtle
    sui-rounded-md sui-px-3 sui-py-5 @sm:sui-py-12"
    >
      <Link href={url} variant="body-sm" color="medium">
        Add materials to your list
      </Link>
      <div className="sui-flex sui-gap-4 sui-items-center">
        <Drill size="regular" color="medium" />
        <CounterTop size="regular" color="medium" />
        <Paint size="regular" color="medium" />
      </div>
    </div>
  );
};

AddMaterialsToYourList.propTypes = {
  url: proptypes.string.isRequired
};

export { AddMaterialsToYourList };
